import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import { useQuery } from '@based/sdk/react'
import { KnowledgeHubItem } from '@schema/knowledgeHubItem'
import { fullName } from '@app/util/helpers'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Card } from '@app/components/blocks/card/Card'
import { Avatar } from '@app/components/core/avatar/Avatar'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Style } from 'inlines'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export interface KnowledgeHubAuthorCardProps {
  authorAvatar?: string
  authorName: string
  authorRole?: string
  style?: Style
}

export const KnowledgeHubModuleContent = ({
  id,
  moduleTitle,
}: {
  id: string
  moduleTitle: string
}) => {
  const itemQuery = useQuery('view-knowledge-hub-item', { id })
  const item: KnowledgeHubItem | undefined = itemQuery.data
  const metaDescription = (item?.description || item?.intro || '').trim()

  return (
    <div>
      {item?.title && (
        <PageSeo
          pageTitle={moduleTitle}
          tabTitle={item.title}
          description={metaDescription}
        />
      )}
      <Title.H1
        style={{
          hyphens: 'auto',
          overflowWrap: 'break-word',
        }}
      >
        {item?.title}
      </Title.H1>
      <div style={{ marginBottom: '3rem' }}>
        <SafeHtml html={item?.content ?? ''} />
      </div>
      <KnowledgeHubAuthorCard
        authorAvatar={item?.author?.avatar}
        authorName={item?.author ? fullName(item.author) : ''}
        authorRole={item?.author?.displayRole}
        style={{ marginBottom: '3rem' }}
      />
    </div>
  )
}

const KnowledgeHubAuthorCard = ({
  authorAvatar,
  authorName,
  authorRole,
  style,
}: KnowledgeHubAuthorCardProps) => {
  return (
    <Card style={{ width: 'fit-content', ...style }}>
      <Row gap="1rem" style={{ alignItems: 'center', margin: '-0.5rem 0' }}>
        <Avatar
          shape="square"
          size="small"
          image={authorAvatar}
          labelSource={authorName}
        />
        <Column gap="0rem">
          <Title.H4 style={{ color: 'var(--gray-900)', margin: 0 }}>
            {authorName}
          </Title.H4>
          {authorRole && (
            <Text.Medium style={{ color: 'var(--gray-900)' }}>
              {authorRole}
            </Text.Medium>
          )}
        </Column>
      </Row>
    </Card>
  )
}
